import { createFcmDetails } from '../shared/factory';

const multilineDescription = `This country and locale fcm enables showing a media consent disclaimer right beneath media upload area.
	For the country you want to enable, create a json there to show which locale(s) are also required.
	Example: South Africa (za): { "en-GB": true } (or { "en-GB": true, "en-US" : true }).`;

export const FCM_DETAILS_FUTURE_SAP_MEDIA_DISCLAIMER = createFcmDetails('future_sap_media_disclaimer', {
	owner: 'Modern Petitioning Pack',
	context: "Start A Petition's media upload page",
	description: multilineDescription,
	import: false,
	template: {
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'en-GB': true,
	},
});
